import { create } from 'zustand'

import { createSelectors } from '../helpers'

type KnotDebugStore = {
  debugMessage: string
  setDebugMessage: (debugMessage: string) => void
}

const initialState: KnotDebugStore = {
  debugMessage: '',
  setDebugMessage: () => {},
}

export const useKnotDebugStore = create<KnotDebugStore>((set) => ({
  ...initialState,
  setDebugMessage: (debugMessage: string) => set({ debugMessage }),
}))

export const useKnotDebugActions = () => {
  const { setDebugMessage } = useKnotDebugStore()
  return {
    setDebugMessage,
  }
}

export const useKnotDebugStoreBase = createSelectors(useKnotDebugStore)
